import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';

import { localization } from '../../../shared/localization/localization';
import { LogoIcon } from 'src/App/shared/icons/pt-icon-logo';
import { LineIcon } from 'src/App/shared/icons/pt-icon-line';
import { TextIcon } from 'src/App/shared/icons/pt-icon-text';
import { RectangleIcon } from 'src/App/shared/icons/pt-icon-rectangle';
import { NextIcon } from 'src/App/shared/icons/pt-icon-next';
import { BackIcon } from 'src/App/shared/icons/pt-icon-back';
import { HelpIcon } from 'src/App/shared/icons/pt-icon-help';
import { MagnetIcon } from 'src/App/shared/icons/pt-icon-magnet';

export interface ILogoEditorImageControlsProps {
    magnetEnabled: boolean;
    onAddLogo(): void;
    onAddText(): void;
    onAddLine(): void;
    onAddRectangle(): void;
    onUndo(): void;
    onRedo(): void;
    onQuestionMarkClick(): void;
    onSaveToGallery(): void;
    onMagnetClick(): void;
}

export class LogoEditorImageControls extends React.Component<ILogoEditorImageControlsProps> {
    constructor(props: ILogoEditorImageControlsProps) {
        super(props);
    }

    public render() {
        return (
            <div className="editor-controls-root">
                <div className="shape-controls">
                    <button className="editor-control-btn"
                            onClick={() => this.props.onAddLogo()}
                            data-tip={true} data-for="btn-add-logo-tip">
                        <LogoIcon />
                    </button>
                    <ReactTooltip id="btn-add-logo-tip" effect='solid' place='right'>
                        <span>{localization.editorLoc.logoEditorContent.toolTips.addLogo}</span>
                    </ReactTooltip>
                    <button className="editor-control-btn"
                            onClick={() => this.props.onAddText()}
                            data-tip={true} data-for="btn-add-text-tip">
                        <TextIcon />
                    </button>
                    <ReactTooltip id="btn-add-text-tip" effect='solid' place='right'>
                        <span>{localization.editorLoc.logoEditorContent.toolTips.addText}</span>
                    </ReactTooltip>
                    <button className="editor-control-btn"
                            onClick={() => this.props.onAddLine()}
                            data-tip={true} data-for="btn-add-line-tip">
                        <LineIcon />
                    </button>
                    <ReactTooltip id="btn-add-line-tip" effect='solid' place='right'>
                        <span>{localization.editorLoc.logoEditorContent.toolTips.addLine}</span>
                    </ReactTooltip>
                    <button className="editor-control-btn"
                            onClick={() => this.props.onAddRectangle()}
                            data-tip={true} data-for="btn-add-rectangle-tip">
                        <RectangleIcon />
                    </button>
                    <ReactTooltip id="btn-add-rectangle-tip" effect='solid' place='right'>
                        <span>{localization.editorLoc.logoEditorContent.toolTips.addRectangle}</span>
                    </ReactTooltip>
                </div>
                <div className="undo-controls">
                    <button className="editor-control-btn"
                            onClick={() => this.props.onUndo()}
                            data-tip={true} data-for="btn-undo-tip"
                            >
                        <BackIcon />
                    </button>
                    <ReactTooltip id="btn-undo-tip" effect='solid' place='right'>
                        <span>{localization.editorLoc.logoEditorContent.toolTips.undo}</span>
                    </ReactTooltip>
                    <button className="editor-control-btn"
                            onClick={() => this.props.onRedo()}
                            data-tip={true} data-for="btn-redo-tip"
                            >
                        <NextIcon />
                    </button>
                    <ReactTooltip id="btn-redo-tip" effect='solid' place='right'>
                        <span>{localization.editorLoc.logoEditorContent.toolTips.redo}</span>
                    </ReactTooltip>
                </div>
                <div className="action-controls">
                    <button className={'shape-toggle-btn' + (this.props.magnetEnabled ? ' shape-toggle-btn-toggled' : '')} 
                            onClick={() => this.props.onMagnetClick()}
                            data-tip={true} data-for="btn-magnet-tip"
                            >
                        <MagnetIcon />
                    </button>
                    <ReactTooltip id="btn-magnet-tip" effect='solid' place='right'>
                        <span>{localization.editorLoc.logoEditorContent.toolTips.toggleMagnet}</span>
                    </ReactTooltip>
                    {/*<button className="editor-control-btn"*/}
                    {/*        onClick={() => this.props.onQuestionMarkClick()}*/}
                    {/*        data-tip={true} data-for="btn-help-tip"*/}
                    {/*        >*/}
                    {/*    <HelpIcon />*/}
                    {/*</button>*/}
                    {/*<ReactTooltip id="btn-help-tip" effect='solid' place='right'>*/}
                    {/*    <span>{localization.editorLoc.logoEditorContent.toolTips.showHelp}</span>*/}
                    {/*</ReactTooltip>*/}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-image-controls.component.tsx